import * as React from "react";

import twMerge from "@replo/design-system/utils/twMerge";
import {
  PANEL_CONTENT_TOP_OFFSET,
  PANEL_PADDING,
} from "@v1/components/canvas/canvas-constants";
import Scrollable from "@v1/components/common/designSystem/Scrollable";

type RightBarLayoutProps = React.PropsWithChildren<{
  rightBarWidth: number;
  rightBarElementRef: React.RefObject<HTMLDivElement>;
  className?: string;
}>;

export const RightBarLayout: React.FC<RightBarLayoutProps> = ({
  rightBarWidth,
  rightBarElementRef,
  children,
  className,
}) => {
  return (
    <div
      className="absolute flex flex-col items-end rounded-xl"
      style={{
        right: PANEL_PADDING,
        top: PANEL_CONTENT_TOP_OFFSET + PANEL_PADDING,
      }}
      ref={rightBarElementRef}
    >
      <div
        style={{
          width: rightBarWidth,
          height: `calc(100vh - ${PANEL_CONTENT_TOP_OFFSET + PANEL_PADDING * 2}px)`,
        }}
        className={twMerge(
          "border-0.5 border-border shadow-xs z-0 overflow-hidden rounded-xl bg-white transition-[width] duration-300 ease-out",
          className,
        )}
      >
        {children}
      </div>
    </div>
  );
};

type RightBarBodyProps = React.PropsWithChildren<{
  isEditMode: boolean;
  className?: string;
}>;
export const RightBarBody: React.FC<RightBarBodyProps> = ({
  children,
  isEditMode,
  className,
}) => {
  return (
    <Scrollable
      // NOTE (Gabe 2023-06-08): The bg-color must exist on this component
      // so that it exists in the same stacking context as the Canvas
      // (positioned) and appropriately overlays it.
      className={twMerge(`h-full w-full rounded-b-xl bg-white`, className)}
      type={isEditMode ? "both" : "vertical"}
      shouldShowScrollbar={false}
    >
      {children}
    </Scrollable>
  );
};
